import Organization from "../Models/Organization";
import { QuestionCategory } from "../Models/QuestionCategory";
import OrganizationAPI from "./organization.api";

export async function getOrganizationQuestionCategories({
  organizationId,
  page = 1,
}) {
  const res = await OrganizationAPI.getOrganizationQuestionCategories({
    organizationId: organizationId,
    page,
  });
  return {
    ...res.data,
    results: res.data.results.map((r) => new QuestionCategory(r)),
  };
}

export async function postOrganizationQuestionCategory({
  organizationId,
  payload,
}) {
  const res = await OrganizationAPI.postOrganizationQuestionCategory({
    organizationId,
    payload,
  });
  return new QuestionCategory(res.data);
}

export async function postCreateOrganization(payload) {
  const res = await OrganizationAPI.postCreateOrganization(payload);
  return new Organization(res.data);
}
export async function postOrganizationWizideeVerification({ organizationId }) {
  return await OrganizationAPI.postOrganizationWizideeVerification({
    organizationId,
  });
}
export async function postOrganizationYousignVerification({ organizationId }) {
  return await OrganizationAPI.postOrganizationYousignVerification({
    organizationId,
  });
}

export async function postOrganizationDocumentGenerate({
  organizationId,
  folderId,
  payload,
}) {
  await OrganizationAPI.postOrganizationDocumentGenerate({
    organizationId,
    folderId,
    payload,
  });
}
export async function postOrganizationToGED({ organizationId, folderId }) {
  await OrganizationAPI.postOrganizationToGED({
    organizationId,
    folderId,
  });
}

export async function patchOrganizationQuestionCategory({
  organizationId,
  categoryId,
  payload,
}) {
  const res = await OrganizationAPI.patchOrganizationQuestionCategory({
    organizationId,
    categoryId,
    payload,
  });
  return new QuestionCategory(res.data);
}

export async function deleteOrganizationQuestionCategory({
  organizationId,
  categoryId,
}) {
  await OrganizationAPI.deleteOrganizationQuestionCategory({
    organizationId,
    categoryId,
  });
}
export async function postOrganizationOfferTemplate({
  organizationId,
  payload,
}) {
  return await OrganizationAPI.postOrganizationOfferTemplates({
    organizationId,
    payload,
  });
}
export async function postOrganizationOfferTemplateFiles({
  organizationId,
  payload,
  offerTemplateId,
}) {
  return await OrganizationAPI.postOrganizationOfferTemplatesFiles({
    organizationId,
    payload,
    offerTemplateId,
  });
}
export async function patchOrganizationOfferTemplate({
  organizationId,
  payload,
  offerTemplateId,
}) {
  return await OrganizationAPI.patchOrganizationOfferTemplates({
    organizationId,
    payload,
    offerTemplateId,
  });
}
export async function getOrganizationDocumentTemplates({ organizationId }) {
  await OrganizationAPI.getOrganizationDocumentTemplates({ organizationId });
}
